import styled from "styled-components";

export const MainDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 20px;
    height: 86px;
    width: inherit;
    background-color: #F2E6FE;
    border-radius: 10px;
    padding: 16px 50px;
`

export const ImageDiv = styled.img`
    height: 13px;
    width: 13px;
`
export const BorderDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 21px;
    width: 21px;
    background-color: #75C7FF;
    border: 3px solid #9ed7ff;
    border-radius: 50%;
`
export const MiddleSection = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 12px 0 12px;
`
export const LongLine = styled.div`
    background-color: #631996;
    border-radius: 20px;
    width: 100%;
    height: 8px;
`